import { Fragment } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { FullscreenCentered, Loader, useWorkData } from '@diana/core';
import { routeUrls } from '../../app/Routing/RouteUrls';

export const LegacyWorkPath = () => {
  const [searchParams] = useSearchParams();
  // @ts-ignore
  const queryParams = Object.fromEntries([...searchParams]) as { id: string; modal: string };

  const {
    work,
    isLoading,
    shouldShowError: isError,
  } = useWorkData({ workId: queryParams.id ?? '', enabled: Boolean(queryParams.id) });

  if (isLoading) {
    return (
      <FullscreenCentered>
        <Loader simple />
      </FullscreenCentered>
    );
  }

  if (isError) {
    return <Navigate to={routeUrls.selectEcosystem.url(null, null)} replace />;
  }

  if (work) {
    const possibleEnvironment = work.flowType?.split('/')[0];
    if (possibleEnvironment) {
      return (
        <Navigate
          to={routeUrls.work.url({ environment: possibleEnvironment, workId: work.id }, {})}
          replace
        />
      );
    }

    // fallback
    return <Navigate to={routeUrls.selectEcosystem.url(null, null)} replace />;
  }

  return <Fragment />;
};
